import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import { getLocalizedString } from "@icarius-localization/strings";
import useImputations from "./useImputations";
import DuplicateDialog from "./dialogs/duplicateDialog/duplicateDialog";
import CreateEditDialog from "./dialogs/createEditDialog/index";
import ViewGridDialog from "./dialogs/viewGridDialog";
import UploadAccountingImputations from "./dialogs/uploadAccountingImputations";
import { FormatListBulleted } from "@icarius-icons";

const AccountingImputations = () => {

  const {
    data,
    entryList,
    conceptList,
    imputationList,
    distributionList,
    conceptsWithoutImputation,
    isLoading,
    state,
    handlers
  } = useImputations();

  const createButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={() => handlers.handleOpenCreateDialog(gridRef)}
      type={"add"}
    />
  )

  const modifyButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenEditDialog(gridRef)}
      type={"edit"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
      type={"delete"}
    />
  )

  const duplicateButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("duplicate")}
      onClick={() => handlers.handleOpenDuplicateDialog(gridRef)}
      type={"duplicate"}
    />
  )

  const downloadButton = () => (
    <CustomIconButton
      title={getLocalizedString("export")}
      onClick={handlers.handleExport}
      type={"download"}
    />
  )

  const uploadButton = () => (
    <CustomIconButton
      title={getLocalizedString("import")}
      onClick={handlers.handleOpenImportDialog}
      type={"upload"}
    />
  )

  const viewButton = () => (
    <CustomIconButton
      title={getLocalizedString("viewUnpostedConcepts")}
      onClick={handlers.handleOpenViewDialog}
    >
      <FormatListBulleted />
    </CustomIconButton>
  )

  return (
    <CommonPage
      isLoading={isLoading}
      title={getLocalizedString("accountingImputations")}
      gridTitle={getLocalizedString("accountingImputations")}
      columnDefPage={paths.accountingImputations}
      rowData={data}
      menuItems={[viewButton, createButton, modifyButton, downloadButton, uploadButton, duplicateButton, deleteButton]}
      hasExpand
      hasHelp
    >
      {
        (state.createDialogIsOpen || state.editDialogIsOpen) &&
        <CreateEditDialog
          open={(state.createDialogIsOpen || state.editDialogIsOpen)}
          isCreate={Boolean(state.createDialogIsOpen)}
          loading={isLoading}
          data={state.selectedDocument}
          handleClose={handlers.handleCloseCreateEditDuplicateDialog}
          entryList={entryList}
          conceptList={conceptList}
          imputationList={imputationList}
          distributionList={distributionList}
        />
      }
      {
        state.duplicateDialogIsOpen && !isLoading &&
        <DuplicateDialog
          open={state.duplicateDialogIsOpen}
          data={state.selectedDocument}
          handleConfirm={handlers.handleDuplicate}
          handleClose={handlers.handleCloseCreateEditDuplicateDialog}
          entryList={entryList}
          conceptList={conceptList}
          imputationList={imputationList}
        />
      }
      {
        state.viewDialogIsOpen && !isLoading &&
        <ViewGridDialog
          open={state.viewDialogIsOpen}
          data={conceptsWithoutImputation}
          handleClose={handlers.handleCloseViewDialog}
        />
      }
      {
        state.importDialogIsOpen &&
        <UploadAccountingImputations
          open={state.importDialogIsOpen}
          isLoading={isLoading}
          handleClose={handlers.handleCloseImportDialog}
        />
      }
    </CommonPage>
  )
}

export default AccountingImputations;